/* 接口地址 */

import http from '../util/request'

// 使用租户名，获得租户编号
export const getTenantIdByName = params => {
  return http.get('/app-api/system/tenant/get-id-by-name', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}
// 登录
export const loginSystem = params => {
  return http.post('/app-api/app/client/auth/login', params, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
}
// 获取问题列表
export const getQuestionList = params => {
  return http.post('/app-api/cs/knowledge-type/getKnowledgeTypeTree', params, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
}
// 获取历史聊天记录
export const getChatHistory = params => {
  return http.get('/app-api/cs/dialogue-record/history', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}
// 获取当前会话id和问题id
export const getConversationInfo = params => {
  return http.get('/app-api/cs/context/get', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}
// 获取当前会话内容
export const getConversation = params => {
  return http.get('/app-api/cs/dialogue-record/current', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}
// 提交评价
export const submitEvaluate = params => {
  return http.post('/app-api/cs/feedback/score', params, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
}
// 记录转人工
export const recordPhone = params => {
  return http.put('/app-api/cs/dialogue/toManual', params, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
}
// 取消转人工
export const cancelPhone = params => {
  return http.put('/app-api/cs/dialogue/cancelManual', params, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
}
// 检查当前token是否过期
export const checkExpired = params => {
  return http.get(`/app-api/app/client/auth/isExpire/${params}`, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
}

// 中化登录
export const authorize = params => {
  return http.get('/app-api/app/client/auth/zh/authorize', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}
// 获取配置信息
export const getConfigInfo = params => {
  return http.get('/app-api/app/client/auth/client/info', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}

// 是否在服务时间
export const isServicingTime = params => {
  return http.get('/app-api/cs/config-workday/isServicingTime', {
    params: params,
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  })
}



// WEBPACK FOOTER //
// ./src/service/getData.js